import { Drawing, DrawingType } from '@editor/interfaces/drawing'

/**
 * Checks if the given item is a Drawing.
 *
 * @param item The item to check.
 * @returns
 */
export const isDrawing = (item: object): item is Drawing => 'drawing_parameters' in item && 'drawing_type' in item

export const isDrawingOfType = <T extends Drawing['drawing_parameters']>(
  item: Drawing,
  type: DrawingType,
): item is Drawing<T> => item.drawing_type === type

/**
 * Filters a collection of drawings by type and excludes certain IDs.
 *
 * @param items Collection of drawings to filter.
 * @param type The type of drawings to include.
 * @param excludeUuids Array of drawing UUIDs to exclude.
 */
export const getDrawingsOfType = <T extends Drawing['drawing_parameters']>(
  items: Drawing[],
  type: DrawingType,
  excludeUuids: string[] = [],
): Drawing<T>[] =>
  items.reduce<Drawing<T>[]>((acc, item) => {
    if (isDrawingOfType<T>(item, type) && !excludeUuids.includes(item.drawing_parameters.uuid)) {
      acc.push(item)
    }
    return acc
  }, [])
